import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListAdjustmentFeesAction = "LIST_ADJUSTMENT_FEES";
const Waiting = "WAITING_FEES";

const initialState = {
    adjustmentlist: [],
    nowWainting: false,
};
export const actionCreators = {
    /**
     * 精算-手数料一覧リスト用データの取得
     */
    listAdjustmentFees: (token, targetDate) => async (dispatch) => {
        var routeurl = `api/user/feeManagements/adjustmentlist`;

        routeurl += `?targetDate=${targetDate}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const adjustmentlist = await response.json();
                dispatch({ type: ListAdjustmentFeesAction, adjustmentlist });
                return adjustmentlist;
            } else {
                throw new Error('手数料一覧の取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 精算-手数料一覧リストを初期化します。
     */
    initListAdjustmentFees: () => async (dispatch) => {
        dispatch({ type: ListAdjustmentFeesAction, adjustmentlist: [], nowWainting: false });
    },
 }

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListAdjustmentFeesAction) {
        return {
            ...state,
            adjustmentlist: action.adjustmentlist,
            nowWainting: action.nowWainting
        };
    }
    return state;
}